import {
  Button,
  ChevronDownIcon,
  Divider,
  Grid,
  GridChild,
  Icon,
  OverflowMenu,
  OverflowMenuButton,
  OverflowMenuGroup,
  PersonIcon,
  Typography,
} from '@norges-domstoler/dds-components';
import { useTranslation } from 'react-i18next';
import { Paths } from 'src/Routes';
import { useAuth } from 'src/contexts/AuthContext';
import { NavLink, useNavigate } from 'react-router';
import { useCallback } from 'react';
import { useLoggedInStatus } from 'src/contexts/LoggedInStatusContext';

const headerSectionClassName = 'flex w-full items-center gap-8';

const headerLinkClassName = 'text-inherit no-underline';

const headerTitleClassName = 'mt-[-4px] whitespace-nowrap text-xl font-normal';

const getHeaderNavLinkClassName = ({ isActive }: { isActive: boolean }) =>
  [
    'px-2 py-4 text-inherit no-underline',
    isActive ? 'bg-sky-100 text-sky-900' : '',
  ]
    .filter(Boolean)
    .join(' ');

export const AuthenticatedHeader = () => {
  const { t } = useTranslation();
  return (
    <>
      <Grid as="header">
        <GridChild columnsOccupied="all">
          <section
            className={`${headerSectionClassName} min-h-[52px] text-inherit`}
          >
            <NavLink className={headerLinkClassName} to={Paths.base}>
              <div className={headerTitleClassName}>
                {t('header.page.title')}
              </div>
            </NavLink>
            <NavLink
              className={getHeaderNavLinkClassName}
              to={Paths.behov.base}
            >
              {t('header.links.report')}
            </NavLink>
            <NavLink
              className={getHeaderNavLinkClassName}
              to={Paths.fritak.base}
            >
              {t('header.links.fritak')}
            </NavLink>
            <NavLink
              className={getHeaderNavLinkClassName}
              to={Paths.overfoering.base}
            >
              {t('header.links.overfoering')}
            </NavLink>
            <ProfileLink />
          </section>
        </GridChild>
      </Grid>
      <Divider color="subtle" />
    </>
  );
};

const ProfileLink = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { logout } = useLoggedInStatus();
  const navigate = useNavigate();

  const goToProfile = useCallback(() => {
    navigate(Paths.profil.base);
  }, [navigate]);

  return user ? (
    <div className="ml-auto flex items-center">
      <NavLink
        to={Paths.profil.base}
        className="flex items-center gap-2 text-inherit no-underline"
        id="nav-link"
        data-testid="header-name-link"
      >
        <Icon icon={PersonIcon} />
        <div className="flex flex-col">
          {`${user.fornavn} ${user.etternavn}`}
          <Typography as="span" typographyType="body-short-xsmall">
            {user.enhet
              ? `${user.enhet.navn} (${user.enhet.nummer})`
              : t('enhet.empty')}
          </Typography>
        </div>
      </NavLink>

      <OverflowMenuGroup>
        <Button
          purpose="secondary"
          size="small"
          icon={ChevronDownIcon}
          aria-label={t('aria.user.menu')}
        />
        <OverflowMenu data-testid="user-context-menu">
          <OverflowMenuButton onClick={goToProfile}>
            {t('profil.heading')}
          </OverflowMenuButton>
          <OverflowMenuButton onClick={logout}>
            {t('logout.button.label')}
          </OverflowMenuButton>
        </OverflowMenu>
      </OverflowMenuGroup>
    </div>
  ) : (
    <></>
  );
};
